import { useState, useEffect } from 'react';

export interface ScreenSize {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  width: number;
}

/** Prefer host page width — iframe inner/outer width is often narrower than the real viewport. */
const getHostViewportWidth = (): number => {
  try {
    const parentWidth = (parent as any)?.window?.innerWidth;
    if (typeof parentWidth === 'number' && parentWidth > 0) {
      return parentWidth;
    }
  } catch {
    // cross-origin parent
  }
  return typeof window !== 'undefined' ? window.innerWidth : 1200;
};

export const useResponsive = (): ScreenSize => {
  const [screenSize, setScreenSize] = useState<ScreenSize>({
    isMobile: false,
    isTablet: false,
    isDesktop: true,
    width: typeof window !== 'undefined' ? getHostViewportWidth() : 1200
  });

  useEffect(() => {
    const handleResize = () => {
      const width = getHostViewportWidth();
      const isMobileWidth = width < 500;
      setScreenSize({
        isMobile: isMobileWidth,
        isTablet: width >= 500 && width <= 700,
        isDesktop: width > 700,
        width
      });
      if((parent as any)?.window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv")){
        (parent as any).window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv").style.height = "auto";
      }

      // Mobile widget only: keep host container tall enough for the mobile form
      if (isMobileWidth) {
        if((parent as any)?.window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv")){
          (parent as any).window.document.getElementById("37316DCF-9BB6-4B80-BE26-7651D87C5F6B_outerRGdiv").style.minHeight = "600px";
        }
        if(parent.window.document.getElementById("86A3B1AA-E95E-45EE-B4E7-34B40AFAC538_Iframe")!=null){
            (parent as any)?.changeIframeHeight(600);
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    try {
      (parent as any)?.window?.addEventListener('resize', handleResize);
    } catch {
      // cross-origin parent
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      try {
        (parent as any)?.window?.removeEventListener('resize', handleResize);
      } catch {
        // ignore
      }
    };
  }, []);

  return screenSize;
};
